import {APP_LOCAL_STORAGE_CONTENT_SEEN_PREFIX} from 'shared/Storage/constants/localStorageKeys';
import {GW_SESSION_UUID_KEY, SESSION_STORAGE_LOCATION_INFO, SESSION_STORAGE_POLICY_TYPE} from 'types/SessionNamespace';

const oktaStoragePrefix = 'okta';

export const clearLocalStorageWithExemptions = () => {
  const exemptOktaStorage = window.location.pathname === '/customers/implicit/callback';
  const keys = Object.keys(localStorage).filter(
    (key) =>
      key.startsWith(APP_LOCAL_STORAGE_CONTENT_SEEN_PREFIX) || (exemptOktaStorage && key.startsWith(oktaStoragePrefix))
  );
  const storage = {...localStorage};

  localStorage.clear();
  keys.forEach((key) => {
    localStorage.setItem(key, storage[key]);
  });
};

export const clearSessionStorageWithExemptions = () => {
  const aemQuoteAddressSessionObject = sessionStorage.getItem(SESSION_STORAGE_LOCATION_INFO);
  const aemQuoteTypeSessionObject = sessionStorage.getItem(SESSION_STORAGE_POLICY_TYPE);
  const gwUUID = sessionStorage.getItem(GW_SESSION_UUID_KEY);

  sessionStorage.clear();

  //reset the session  objects set by AEM required by quoting
  if (aemQuoteAddressSessionObject && aemQuoteTypeSessionObject) {
    sessionStorage.setItem(SESSION_STORAGE_LOCATION_INFO, aemQuoteAddressSessionObject);
    sessionStorage.setItem(SESSION_STORAGE_POLICY_TYPE, aemQuoteTypeSessionObject);
  }

  //reset the guidewire session object for use with edge/quoting requests
  if (gwUUID) {
    sessionStorage.setItem(GW_SESSION_UUID_KEY, gwUUID);
  }
};
